/**
 * @generated SignedSource<<9586b6eafb5cb11149649eac0da3a073>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type assignableSuggestionTooltipQuery$variables = {
  id: string;
};
export type assignableSuggestionTooltipQuery$data = {
  readonly employeeGuidance: {
    readonly promptManager: string | null;
    readonly promptReport: string | null;
  } | null;
};
export type assignableSuggestionTooltipQuery = {
  response: assignableSuggestionTooltipQuery$data;
  variables: assignableSuggestionTooltipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptManager",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptReport",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignableSuggestionTooltipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmployeeGuidance",
        "kind": "LinkedField",
        "name": "employeeGuidance",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignableSuggestionTooltipQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EmployeeGuidance",
        "kind": "LinkedField",
        "name": "employeeGuidance",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91a3ec0ea2a4cbfa411d6ee979841de3",
    "id": null,
    "metadata": {},
    "name": "assignableSuggestionTooltipQuery",
    "operationKind": "query",
    "text": "query assignableSuggestionTooltipQuery(\n  $id: ID!\n) {\n  employeeGuidance(topicId: $id) {\n    promptManager\n    promptReport\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ee8ebd521b171744e13acd071f65f46";

export default node;
